import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

const HomePage = overridable('HomePage', () => import(/* webpackChunkName: "home" */ './views/HomePage.vue'));

export default defineModule({
    id: 'home',
    requires: ['games'],
    routes: [
        { path: '/', name: 'home', component: HomePage },
        { path: '/register', name: 'register', component: HomePage }
    ],
    contributes: {
        'app.global': [
            { key: 'contactModal', component: overridable('ContactModal', () => import(/* webpackChunkName: "home" */ './components/ContactModal.vue')) }
        ],
        'sidebar.menu': [
            { key: 'home', order: 0, icon: 'images/menu/home.png', to: '/', mobileHidden: true }
        ],
        'bottom.nav': [
            { key: 'home', order: 0, icon: 'images/menu/home.png', to: '/' },
            { key: 'services', order: 30, icon: 'images/icons/shortcut-support.png', action: 'open-contact' }
        ],
        'home.shortcuts': [
            { key: 'referrer', order: 40, icon: 'images/icons/shortcut-referrer.png' },
            { key: 'support', order: 50, icon: 'images/icons/shortcut-support.png', action: 'open-contact' }
        ],
        'home.sections': [
            { key: 'menuBar', order: 10, component: overridable('MenuBar', () => import(/* webpackChunkName: "home" */ './components/MenuBar.vue')) }
        ]
    }
});
